import { Injectable } from '@angular/core';
import {
   ActivatedRouteSnapshot,
   CanActivate,
   CanActivateChild,
   CanLoad,
   Route,
   Router,
   RouterStateSnapshot,
} from '@angular/router';
import { ROUTES } from '../enums/routes';
import { AuthenticationService } from '../authentication.service';

@Injectable({
   providedIn: 'root',
})
export class AuthGuardUnlogged implements CanActivate, CanActivateChild, CanLoad {
   constructor(private authService: AuthenticationService, private router: Router) {}

   canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
      return this.checkUnlogged(state.url);
   }

   canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
      return this.canActivate(route, state);
   }

   canLoad(route: Route): boolean {
      const url: string = route.path;
      return this.checkUnlogged(url);
   }

   checkUnlogged(url: string): boolean {
      if (!this.authService.isAuthenticated()) {
         return true;
      }
      // Redirect to HOME
      this.router.navigate([ROUTES.HOME]);
      return false;
   }
}
